import { FullPageLoader, PageContentLayout } from '@tassomutuo-backoffice/ui';
import DashboardHeaderSection from './components/DashboardHeaderSection';
import { Box, Typography } from '@mui/material';

import useStatistics from './hooks/useStatistics';
import DashboardTeamMemberStatistics from './components/DashboardTeamMemberStatistics';
import DashboardDeepDiveDropReasons from './components/DashboardDeepDiveDropReasons';
import useDashboardPdf from './hooks/useDashboardPdf';
import { useRef } from 'react';

const DashboardDeepDiveTeamPage = () => {
  const { isPrinting, generatePdf } = useDashboardPdf({ from: 'deep-dive' });
  const contentPrintableRef = useRef<HTMLDivElement>(null);

  const {
    isPending,
    error,
    selectedPeriod,
    setSelectedPeriod,
    selectedMember,
    setSelectedMember,
    teamGroups,
    memberSelectOptions,
    selectedGroupId,
    setSelectedGroupId,
    //statisticsToShow,
    benchmarkStatistics,
    teamMembersStatistics,
    dateRange,
    setDateRange,
    getFilterText,
  } = useStatistics({ from: 'deep-dive' });

  return (
    <Box sx={{ backgroundColor: '#E9EAEB', minHeight: '100vh' }}>
      <FullPageLoader show={isPending || isPrinting} />

      <PageContentLayout error={error} containerSx={{ pt: 0 }}>
        <DashboardHeaderSection
          title="Deep Dive Team"
          subtitle=""
          selectedPeriod={selectedPeriod}
          setSelectedPeriod={setSelectedPeriod}
          selectedMember={selectedMember}
          setSelectedMember={setSelectedMember}
          teamGroups={teamGroups || []}
          memberSelectOptions={memberSelectOptions}
          selectedGroupId={selectedGroupId}
          setSelectedGroupId={setSelectedGroupId}
          hideMemberSelect
          dateRange={dateRange}
          setDateRange={setDateRange}
          onExportPdfClick={() =>
            generatePdf('download', contentPrintableRef, getFilterText())
          }
        />

        {!selectedMember ||
        (selectedMember && !!selectedMember.hubspotOwnerId) ? (
          <Box
            ref={contentPrintableRef}
            sx={{ px: 0, pb: 4, width: isPrinting ? 1100 : undefined }}
          >
            {!selectedMember && teamMembersStatistics && (
              <>
                <Box style={{ pageBreakAfter: 'always', breakAfter: 'page' }}>
                  <DashboardTeamMemberStatistics
                    teamMembersStatistics={teamMembersStatistics}
                    benchmarkStatistics={benchmarkStatistics}
                    isPrinting={isPrinting}
                  />
                </Box>
                <DashboardDeepDiveDropReasons
                  teamMembersStatistics={teamMembersStatistics}
                  benchmarkStatistics={benchmarkStatistics}
                  isPrinting={isPrinting}
                />
              </>
            )}
          </Box>
        ) : (
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" fontWeight="bold" px={4} pt={1}>
              Non ci sono dati da mostrare per il membro selezionato
            </Typography>
          </Box>
        )}
      </PageContentLayout>
    </Box>
  );
};

export default DashboardDeepDiveTeamPage;
